import React, { useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import allPlugins from "../../utils/suneditorPlugins";
import apiClient, { getEditorUploadConfig } from '../../services/apiClient';
import "./custom.css";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom/dist/umd/react-router-dom.development";

function SendToCustomerInfoModal2({ showModal, closeModal,type,id,title,Title2,placeholder,questionstate}) {
  const [content, setContent] = useState('');
  const [subject, setSubject] = useState('');
  const [email, setEmail] = useState('');
  const editorRef = useRef(null);
  const backendUrl = process.env.REACT_APP_BACKEND_URL;

  const [emailtemplate, setEmailtemplate] = useState([]);

  const [EventData, setEventData] = useState({});
  const { eventID,documentId } = useParams();
  const [isProcessing, setIsProcessing] = useState(false);

  const navigate = useNavigate();

  // Function to handle content changes from the editor
  const handleEditorChange = (newContent) => {
    setContent(newContent);
  };

  const handleEmailChange = (e) => {
    const updatedEmail = e.target.value;
    setEventData((prevState) => ({
      ...prevState,       // Keep the other properties of EventData intact
      cl_email: updatedEmail // Update only the cl_email field
    }));
  };

  // Function to update editor content when state changes
  useEffect(() => {
    if (editorRef.current) {
      editorRef.current.editor.setContents(content);
    }
  }, [content]);

  // Function to toggle placeholder visibility
  const handlePlaceholder = () => {
    
    if (editorRef.current) {
     // alert("dhirendra");
      const editor = editorRef.current.editor;
      alert(editor.getContents());
      const placeholder = document.querySelector('.editor-placeholder');
      if (editor.getContents() === '') {
        placeholder.classList.remove('hidden');
      } else {
        placeholder.classList.add('hidden');
      }
    }
  };

  // Update placeholder visibility on content change
  useEffect(() => {
    handlePlaceholder();
  }, [content]);

  // Function to initialize modal
  const initializeModal = () => {
    if (window.bootstrap && modalRef.current) {
      const modalInstance = new window.bootstrap.Modal(modalRef.current);
      return modalInstance;
    }
    return null;
  };

  const modalRef = useRef(null);
  const [formData, setFormData] = useState({
    mainLogo: "",
    secondaryLogo: "",
    defaultHeaderImage: "",
  });

  // Options for the SunEditor instance
  const editorOptions = {
    height: 200,
    plugins: allPlugins,
    ...getEditorUploadConfig(),
    buttonList: [
      [
        "codeView",
        "paragraphStyle",
        "bold",
        "underline",
        "italic",
        "strike",
        "table",
        "link",
        "horizontalRule",
        "list",
        "align",
        "hiliteColor",
        "image",
        "video",
      ],
    ],
    imageRotation: false,
    fontSize: [12, 14, 16, 18, 20],
    toolbarPosition: 'bottom',
    colorList: [
      [
        "#828282",
        "#FF5400",
        "#676464",
        "#F1F2F4",
        "#FF9B00",
        "#F00",
        "#fa6e30",
        "#000",
        "rgba(255, 153, 0, 0.1)",
        "#FF6600",
        "#0099FF",
        "#74CC6D",
        "#FF9900",
        "#CCCCCC",
      ],
    ],
  };

  const [phone, setPhone] = useState();
  const [companyemail, setCompanyemail] = useState();
  const [fname, setFname] = useState();
  const [lname, setLname] = useState();
  const [companyname, setCompanyname] = useState();

  const [selectedTemplate, setSelectedTemplate] = useState('');

  // Handle when the user selects a template
  const handleChange = (e) => {
    setSelectedTemplate(e.target.value); // Update the selected template based on value

    const selectedValue = e.target.value;


    const selectedTemplateObj = emailtemplate.find(template => template.content === selectedValue);

    if (selectedTemplateObj) {
      //setSelectedTemplate(selectedTemplateObj.title);
      //setContent(selectedTemplateObj.content);
      setSubject(selectedTemplateObj.title); // Set the subject from template
    }

    setContent(e.target.value);
  };

  useEffect(() => {
    const modalInstance = initializeModal();
    if (modalInstance) {
      if (showModal) {
        modalInstance.show();
      } else {
        modalInstance.hide();
      }
    }
  }, [showModal]);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await apiClient.get(`/userdetaila/${JSON.parse(localStorage.getItem('user')).user.id}`);

        setFormData({
          mainLogo: response.data.usersdetails[0].Main_Logo ? process.env.REACT_APP_BACKEND_URL + response.data.usersdetails[0].Main_Logo : null,
          secondaryLogo: response.data.usersdetails[0].Secondary_Logo ? process.env.REACT_APP_BACKEND_URL + response.data.usersdetails[0].Secondary_Logo : null,
          defaultHeaderImage: response.data.usersdetails[0].Header_Images ? process.env.REACT_APP_BACKEND_URL + response.data.usersdetails[0].Header_Images : null,
        });

        setPhone(response.data.usersdetails[0].Phone_Number);
        setCompanyemail(response.data.usersdetails[0].Company_Email);

        setFname(response.data.usersdetails[0].first_name);
        setLname(response.data.usersdetails[0].last_name);
        setCompanyname(response.data.usersdetails[0].companyname);

        if (response.data.usersdetails[0].Secondary_Logo) {
          //setContent(`<p class="smart_text"><img src="${response.data.usersdetails[0].Secondary_Logo}" alt='Main Logo Preview' style='width: 200px; height:auto;'/></p>`);
        }
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    };
    fetchUserData();


    const fetchEventDetails = async () => {
      try {
        const response = await apiClient.get(`/event/${eventID}`);
        if (response.data.success === true) {
          setEventData(response.data.events);
        }
      } catch (error) {
        console.error('Error fetching event details:', error);
      }
    };
    
    fetchEventDetails();

    const fetchemailtemplates = async () => {
      try {
        const response = await apiClient.get(`/getemail-templates/${JSON.parse(localStorage.getItem('user')).user.id}`);
        const data = response.data;
       // setEmailtemplate(response.data);
        setEmailtemplate(Array.isArray(data) ? data : [data]);
      } catch (error) {
        console.error('Error fetching event details:', error);
      }
    };
    
    fetchemailtemplates();

  }, []);


  const sendtocustomer = async () => {

    if (isProcessing) return; // Prevent multiple clicks

    setIsProcessing(true);


    try {
      const response = await apiClient.post(`/sendquote`, 
                    {user_id: JSON.parse(localStorage.getItem('user')).user.id,
                     user_email:companyemail,
                     details:content,
                     subject:subject,
                     email_to:EventData.cl_email,
                     logo:formData.secondaryLogo,
                     type:type,
                     id:id,
                     eventID:eventID,
                     title:title,
                     title2:Title2,
                     placeholder:placeholder,
                     questionstate:JSON.stringify(questionstate),
                    });

                    if(response.data.success){
                      


                       Swal.fire({
                        icon: "success",
                        title: "Success",
                        text: "Email sent Sucessfully!",
                        confirmButtonText: 'OK',
                        allowOutsideClick: false, // Disable closing by clicking outside
                        allowEscapeKey: false,    // Disable closing by pressing Escape
                        allowEnterKey: false,     // Disable closing by pressing Enter
                        showCancelButton: false   // Hide the cancel button
                      }).then((result) => {
                        if (result.isConfirmed) {

                         document.getElementById('closemodel').click();
                         navigate("/events");
                        }
                      });

                       
                     }

    } catch (error) {
      console.error("Error fetching contracts:", error);
    }
  };



  return (
    <div
      className='modal fade'
      id='exampleModal2'
      ref={modalRef}
      tabIndex='-1'
      aria-labelledby='exampleModalLabel'
      aria-hidden='true'
    >
      <div
        className='modal-dialog modal-lg modal-dialog-centered'
        role='document'
        style={{ minHeight: "700px" }}
      >
        <div className='modal-content'>
          {/* Modal header */}
          <div className='modal-header bg-primary'>
            <h5 className='modal-title text-white w-100 text-center'>
              Send To Customer new 
            </h5>
            <button type='button' className='close' data-bs-dismiss='modal' id='closemodel'>
              <span aria-hidden='true' className='modal_button'>
                <i className='fas fa-close'></i>
              </span>
              <span className='sr-only'>Close</span>
            </button>
          </div>
          <div
            className='modal-body py-5 px-4'
            style={{ background: "#f1f5f9" }}
          >
            <div className='row'>
              <div className='col-lg-12 col-md-12'>
                <div className='col-md-12 d-flex'>
                  <label htmlFor='eventName' className='labelcls'>
                    EMAIL TO 
                  </label>
                  <input
                    name='eventName'
                    id='eventName'
                    type='text'
                    className='form-control'
                    placeholder='participants'
                    value={EventData.cl_email}
                    required
                    onChange={handleEmailChange}
                  />
                </div>
              </div>
            </div>
            <div className='row'> &nbsp;</div>
            <div className='row'>
              <div className='col-lg-12 col-md-12'>
                <div className='col-md-12 d-flex'>
                  <label htmlFor='eventName' className='labelcls'>
                    SUBJECT
                  </label>
                  <input
                    name='eventName'
                    id='eventName'
                    type='text'
                    className='form-control'
                    placeholder='what is topic?'
                    value={subject}
                    required
                    onChange={(e)=>setSubject(e.target.value)}
                  />
                </div>
              </div>
            </div>
            <div className='row'> &nbsp;</div>
            <div className='row event'>
                    <p class="smart_text"><img 
                        src={formData.secondaryLogo}
                        alt='Main Logo Preview' 
                        style={{width: '100px', height: 'auto'}} 
                      /></p>
              <SunEditor
                setOptions={editorOptions}
                ref={editorRef}
                setContents={content}
                onChange={handleEditorChange}
              />
              <div className={`editor-placeholder ${content!="" ? 'hidden' : ''}`}>
              {`type {to add a smart field` }
              </div>
            </div>
            <div className='row'> &nbsp;</div>

            <div className='row'>
              <div className='col-lg-12 col-md-12 d-flex'>
                <div className='col-md-8'>
                  <label htmlFor='eventName' className='labelcls'>
                    Templates
                  </label>

                  <select value={selectedTemplate} onChange={handleChange}>
                            <option value="">Select a template</option>
                            {
  Array.isArray(emailtemplate) && emailtemplate.map((template) => (
    <option key={template.id} value={template.content}>
      {template.title}
    </option>
  ))
}
                </select>

                
                  
                </div>

                <div className='col-md-4'>
                            <button type='button' className='but-primary' onClick={sendtocustomer} disabled={isProcessing}>
                                  {isProcessing ? "Processing..." : "Send"} 
                            </button>
               </div>


              </div>
            </div>

            
            <div className='row'> &nbsp;</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SendToCustomerInfoModal2;
